/* OXYZENE — contrôleur unique du parcours « Ajouter au panier » de la PDP Sommeil.
 *
 * SOURCE DE VÉRITÉ UNIQUE. Ce fichier possède, du clic jusqu'au tiroir :
 *   .oxs-cta · [data-oxs-skbtn] · form#oxsForm-* · [data-oxu-add] · [data-oxu-skip]
 *   + le fond de la modale et la touche Échap
 *
 * Ne rebranchez aucun écouteur sur ces sélecteurs ailleurs (section, snippet, app).
 * Le rendu du tiroir est délégué à cart-drawer.renderContents().
 *
 * PIÈGE 1 : ne jamais lire form.id sur ce formulaire. Il contient un
 * <input name="id"> pour la variante, et les champs d'un formulaire sont exposés
 * comme propriétés de celui-ci par leur name. form.id renvoie donc la RadioNodeList
 * des variantes, pas la chaîne "oxsForm-...". Toujours passer par getAttribute('id').
 *
 * PIÈGE 2 : /discount/CODE1,CODE2 ne fonctionne pas — Shopify traite la chaîne
 * entière comme un seul code, qu'il refuse. Un code par requête, en série.
 *
 * PIÈGE 3 : ne jamais afficher le HTML de section renvoyé par /cart/add.js.
 * Sur une session sans panier préexistant (navigation privée, premier ajout),
 * le panier est créé PAR cette requête et les sections sont rendues avant qu'il
 * existe : Shopify renvoie un tiroir vide alors que l'article est bien ajouté.
 *
 * PIÈGE 4 : ne pas demander les sections à l'URL de la page courante. Sur le
 * template product.sommeil, Shopify ignore les sections demandées et répond
 * {"product": ...} — on affichait alors un tiroir vide. La racine du site les
 * rend correctement, quel que soit le template de la page.
 */
(function () {
  if (window.__OXY_SOMMEIL_FLOW__) return;
  window.__OXY_SOMMEIL_FLOW__ = true;

  var UPSELL_VARIANT_ID = 64786809487709;

  /* Appliqués dans cet ordre, un par requête. Le premier fixe le Mouth Tape à 18,99 €,
     le second offre la livraison. Les deux restent applicables ensemble. */
  var DISCOUNT_CODES = ['OXY-MT-POPUP-1799', 'OXY-MT-POPUP-FREESHIP'];

  /* En centimes. À aligner avec le seuil réel affiché ailleurs sur le site. */
  var SHIPPING_THRESHOLD = 4900;
  var POPUP_WINDOW_MS = (12 * 60 + 54) * 1000;

  var ROUTES = window.routes || {};
  var CART_URL = ROUTES.cart_url || '/cart';
  var ADD_URL = (ROUTES.cart_add_url || '/cart/add') + '.js';
  var UPDATE_URL = (ROUTES.cart_update_url || '/cart/update') + '.js';

  var busy = false;
  var countdownTimer = null;

  /* ------------------------------------------------------------------ outils */

  function attrId(el) {
    return (el && el.getAttribute ? el.getAttribute('id') : '') || '';
  }

  function drawerEl() {
    return document.querySelector('cart-drawer');
  }

  function sectionIds() {
    var d = drawerEl();
    if (d && typeof d.getSectionsToRender === 'function') {
      return d.getSectionsToRender().map(function (s) { return s.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  /* Racine de la boutique, locale comprise. Voir PIÈGE 4. */
  function sectionsBase() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function jsonHeaders() {
    return {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    };
  }

  function readCart() {
    return fetch(CART_URL + '.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (r) {
      if (!r.ok) throw new Error('cart-read-' + r.status);
      return r.json();
    });
  }

  function fetchSections() {
    var ids = sectionIds();
    var url = sectionsBase() + '?sections=' + ids.join(',') + '&_oxy=' + Date.now();
    return fetch(url, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (r) {
      if (!r.ok) throw new Error('sections-' + r.status);
      return r.json();
    }).then(function (sections) {
      /* Garde-fou : si le tiroir n'est pas dans la réponse, on ne rend rien
         plutôt que d'écraser un tiroir correct par du vide. */
      if (!sections || typeof sections['cart-drawer'] !== 'string') {
        throw new Error('sections-tiroir-absent');
      }
      return sections;
    });
  }

  /* Seul chemin d'affichage du tiroir : on relit toujours les sections au serveur. */
  function openCartDrawer(productId) {
    return fetchSections().then(function (sections) {
      var d = drawerEl();
      if (d && typeof d.renderContents === 'function') {
        d.renderContents({ id: productId, sections: sections });
        return true;
      }
      window.location.href = CART_URL;
      return false;
    }).catch(function (err) {
      console.error('[OXYZENE] ouverture du tiroir', err);
      window.location.href = CART_URL;
      return false;
    });
  }

  /* Un code par requête, en série. */
  function applyDiscounts() {
    return DISCOUNT_CODES.reduce(function (chain, code) {
      return chain.then(function () {
        return fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(CART_URL + '.js'), {
          credentials: 'same-origin',
          redirect: 'follow',
          cache: 'no-store'
        }).catch(function (e) {
          console.error('[OXYZENE] code promo ' + code, e);
        });
      });
    }, Promise.resolve());
  }

  function safeSessionGet(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }

  function safeSessionSet(key, value) {
    try { sessionStorage.setItem(key, value); } catch (e) {}
  }

  /* ----------------------------------------------------------------- modale */

  function modalOfForm(form) {
    try {
      var id = attrId(form).replace('oxsForm-', '');
      return id ? document.getElementById('oxs-upsell-' + id) : null;
    } catch (e) {
      console.error('[OXYZENE] modale introuvable', e);
      return null;
    }
  }

  function formOfTrigger(trigger) {
    if (!trigger) return null;
    var inForm = trigger.closest('form[id^="oxsForm-"]');
    if (inForm) return inForm;
    var bar = trigger.closest('[id^="oxs-sticky-"]');
    if (bar) {
      var id = attrId(bar).replace('oxs-sticky-', '');
      return id ? document.getElementById('oxsForm-' + id) : null;
    }
    return null;
  }

  function startCountdown(modal) {
    var out = modal.querySelector('[data-oxu-countdown]');
    var addBtn = modal.querySelector('[data-oxu-add]');
    if (!out) return;

    var key = 'oxu-popup-deadline';
    var deadline = parseInt(safeSessionGet(key) || '0', 10);
    if (!deadline || deadline <= Date.now()) {
      deadline = Date.now() + POPUP_WINDOW_MS;
      safeSessionSet(key, String(deadline));
    }

    function tick() {
      var left = Math.max(0, deadline - Date.now());
      var total = Math.ceil(left / 1000);
      var mm = String(Math.floor(total / 60));
      var ss = String(total % 60);
      out.textContent = (mm.length < 2 ? '0' + mm : mm) + ':' + (ss.length < 2 ? '0' + ss : ss);
      if (!left) {
        clearInterval(countdownTimer);
        countdownTimer = null;
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Offre expirée'; }
      }
    }

    tick();
    if (countdownTimer) clearInterval(countdownTimer);
    countdownTimer = setInterval(tick, 1000);
  }

  function updateShippingBar(modal) {
    var text = modal.querySelector('[data-oxu-shiptext]');
    var fill = modal.querySelector('[data-oxu-shipfill]');
    if (!text || !fill) return;

    readCart().then(function (cart) {
      var total = cart.total_price || 0;
      var left = Math.max(0, SHIPPING_THRESHOLD - total);
      fill.style.width = Math.min(100, Math.max(0, (total / SHIPPING_THRESHOLD) * 100)) + '%';
      if (left > 0) {
        var amount = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(left / 100);
        text.textContent = 'Encore ' + amount + ' avant la livraison offerte';
      } else {
        text.textContent = 'Livraison offerte débloquée';
        fill.style.width = '100%';
      }
    }).catch(function () {
      text.textContent = 'Livraison offerte avec cette offre';
      fill.style.width = '100%';
    });
  }

  function openModal(modal) {
    if (!modal) return false;
    try {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('oxs-upsell-open');
      startCountdown(modal);
      updateShippingBar(modal);
      var add = modal.querySelector('[data-oxu-add]');
      if (add) {
        requestAnimationFrame(function () {
          try { add.focus({ preventScroll: true }); } catch (e) {}
        });
      }
      return true;
    } catch (e) {
      console.error('[OXYZENE] ouverture de la modale', e);
      return false;
    }
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('oxs-upsell-open');
    if (countdownTimer) { clearInterval(countdownTimer); countdownTimer = null; }
  }

  /* ----------------------------------------------------------------- parcours */

  function addPrimary(form, button) {
    if (busy || !form) return;

    var fd;
    try { fd = new FormData(form); } catch (e) { return; }
    var variantId = fd.get('id');
    if (!variantId) return;

    busy = true;
    var label = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = 'Ajout en cours…'; }

    /* Pas de sections demandées ici : voir PIÈGE 3. */
    fetch(ADD_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    }).then(function (r) {
      if (!r.ok) throw new Error('primary-add-' + r.status);
      return r.json();
    }).then(function () {
      if (!openModal(modalOfForm(form))) return openCartDrawer(variantId);
    }).catch(function (err) {
      console.error('[OXYZENE] ajout du produit principal', err);
      window.location.href = CART_URL;
    }).finally(function () {
      busy = false;
      if (button) {
        button.disabled = false;
        button.textContent = label || 'Ajouter au panier';
      }
    });
  }

  function addUpsell(modal, button) {
    if (busy) return;
    busy = true;

    var label = button.textContent;
    button.disabled = true;
    button.textContent = 'Ajout en cours…';

    fetch(ADD_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: jsonHeaders(),
      body: JSON.stringify({ items: [{ id: UPSELL_VARIANT_ID, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('upsell-add-' + r.status);
      return r.json();
    }).then(function () {
      return fetch(UPDATE_URL, {
        method: 'POST',
        credentials: 'same-origin',
        headers: jsonHeaders(),
        body: JSON.stringify({ attributes: { _oxu_free_shipping: 'true' } })
      });
    }).then(applyDiscounts).then(function () {
      closeModal(modal);
      button.disabled = false;
      button.textContent = label;
      return openCartDrawer(UPSELL_VARIANT_ID);
    }).catch(function (err) {
      console.error('[OXYZENE] ajout de l’upsell', err);
      button.disabled = false;
      button.textContent = 'Réessayer l’ajout · 18,99 €';
    }).finally(function () {
      busy = false;
    });
  }

  function declineUpsell(modal) {
    closeModal(modal);
    openCartDrawer(null);
  }

  /* ---------------------------------------------------------------- écoutes */

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var upsellAdd = target.closest('[data-oxu-add]');
    if (upsellAdd) {
      var m1 = upsellAdd.closest('[id^="oxs-upsell-"]');
      if (!m1) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      addUpsell(m1, upsellAdd);
      return;
    }

    var upsellSkip = target.closest('[data-oxu-skip]');
    if (upsellSkip) {
      var m2 = upsellSkip.closest('[id^="oxs-upsell-"]');
      if (!m2) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      declineUpsell(m2);
      return;
    }

    if (target.matches && target.matches('[id^="oxs-upsell-"].is-open')) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      declineUpsell(target);
      return;
    }

    var atc = target.closest('.oxs-cta,[data-oxs-skbtn]');
    if (atc) {
      var form = formOfTrigger(atc);
      if (!form) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      addPrimary(form, atc);
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[id^="oxsForm-"]')) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    addPrimary(form, form.querySelector('.oxs-cta'));
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('[id^="oxs-upsell-"].is-open');
    if (!open) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    declineUpsell(open);
  }, true);

  /* ------------------------------------------- prix unitaire de la barre collante */

  function applyStickyPrice() {
    document.querySelectorAll('[id^="oxs-sticky-"]').forEach(function (sticky) {
      var sectionId = attrId(sticky).replace('oxs-sticky-', '');
      var root = document.getElementById('oxs-' + sectionId);
      if (!root) return;
      var checked = root.querySelector('[data-oxs-opt] input[type="radio"]:checked');
      var price = sticky.querySelector('[data-oxs-skprice]');
      if (!checked || !price) return;
      var option = checked.closest('[data-oxs-opt]');
      var title = option && option.querySelector('.oxs-t');
      if (title && /2\s*\+\s*1/i.test(title.textContent || '')) price.textContent = '9,99 € / pack';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyStickyPrice, { once: true });
  } else {
    applyStickyPrice();
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('[data-oxs-opt] input[type="radio"]')) {
      setTimeout(applyStickyPrice, 0);
    }
  });
})();
